import { gql } from '@apollo/client';

export const ALL_INTERVENTION_ROLES = gql`
  query getInterventionRoles {
    interventionRoles: getInterventionRoles {
      id
      name
    }
  }
`;
